<template>
    <div>
        <the-carousel id="carousel"
                      :images="carouselImages"/>
        <div id="mobile-title">
            {{this.$lang.homeSubtitle}}
        </div>
        <div class="info-section body-block">
            <div id="main-block">
                <router-link v-for="(category, index) of dbData.categories.filter(x => x.main)"
                             :key="index"
                             class="main-category"
                             :to="`/catalog/${category.index}`">
                    <image-view class="block-img"
                                type="background"
                                :url="category.image"
                                size="large"/>
                    <div>
                        {{category.title}}
                    </div>
                </router-link>
            </div>
            <div id="other-block">
                <router-link v-for="(category, index) of dbData.categories.filter(x => !x.main)"
                             :key="index"
                             class="other-category"
                             :to="`/catalog/${category.index}`">
                    <!--<img :src="require(`@/assets/${category.icon}-24px.svg`)"/>-->
                    <div>
                        {{category.title}}
                    </div>
                </router-link>
            </div>
        </div>
        <div class="info-section body-block">
            <div id="infoblocks-container">
                <info-block v-for="(infoBlock, index) in infoBlocks"
                            class="infoblock"
                            :key="index"
                            :title="infoBlock.title"
                            :contents="infoBlock.contents"/>
            </div>
            <div id="feed-container">
                <router-link id="feed-title"
                             class="button flat-button"
                             to="/blog">
                    {{this.$lang.homeFeedTitle}}
                </router-link>
                <post v-for="(post, index) in posts"
                      class="post"
                      :key="index"
                      :data="post"
                      :image-hidden="false"/>
            </div>
        </div>
    </div>
</template>

<script>
	import Post from "@/components/Post";
	import InfoBlock from "@/components/InfoBlock";
	import InfoBlockService from "@/services/InfoBlockService";
	import FeedService from "@/services/FeedService";
	import TheCarousel from "@/components/TheCarousel";
	import ImageView from "@/components/ImageView";

	export default {
		name: 'Home',
		components: {ImageView, TheCarousel, InfoBlock, Post},
		props: {
			dbData: {
				type: Object,
				required: true
			}
		},
		created() {
			InfoBlockService.getInfoBlocks().then(result => {
				this.infoBlocks = result;
			});
			FeedService.getPosts(0).then(result => {
				this.posts = result.slice(0, this.displayLimit);
			});
			window.addEventListener("scroll", this.$throttle(this.onScroll, 75));
		},
		data() {
			return {
				homeCard: {
					title: this.$lang.homeTitle,
					description: this.$lang.homeSubtitle,
					image: "front.jpg"
				},
				infoBlocks: [],
				posts: [],
				displayLimit: 4,
				carouselImages: [
					"moco.jpg",
					"http://moco.oss-cn-shanghai.aliyuncs.com/599834562684-c8b339ad.jpg",
					"banner4.jpg"
				],
				throttledScrollTop: 0
			}
		},
		methods: {
			onScroll() {
				this.throttledScrollTop = window.top.scrollY;
			}
		}
	}
</script>

<style scoped lang="scss">
    #carousel {
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 0;

        @media #{$tablet} {
            height: 100vh;
        }

        @media #{$tablet-inv} {
            height: 100vh;
        }
    }

    #mobile-title {
        position: absolute;
        top: calc(75vh - 96px);
        width: 75vw;
        right: 0;
        padding: 16px 16px 16px 24px;
        box-sizing: border-box;
        font-family: $serif;
        font-weight: 700;
        font-size: 28px;
        color: $p-fg;
        background-color: transparentize($p-bg, 0.2);
        backdrop-filter: blur(32px);
        text-align: right;
        border-left: $solid;

        .lang0 & {
            font-size: 32px;
        }

        .lang1 & {
            font-size: 28px;
        }

        @media #{$tablet-inv} {
            display: none;
        }
    }

    #mobile-title::before {
        position: absolute;
        content: "";
        top: 8px;
        left: -9px;
        width: 8px;
        bottom: 8px;
        background-color: $p-accent;
    }

    .info-section {
        position: relative;
        display: flex;
        padding-top: 64px;
        min-height: 420px;

        @media #{$tablet} {
            flex-direction: column;
        }

        @media #{$tablet-inv} {
            flex-direction: row;
        }
    }

    #main-block {
        display: flex;
        flex-grow: 2;

        @media #{$tablet} {
            flex-direction: column;
        }

        @media #{$tablet-inv} {
            flex-direction: row;
        }
    }

    #other-block {
        position: relative;
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        justify-content: space-between;
    }

    .main-category {
        position: relative;
        flex: 1;
        padding: 24px;
        @extend .button;

        @media #{$tablet} {
            min-height: 120px;
            margin-bottom: 16px;
        }

        @media #{$tablet-inv} {
            margin-right: 16px;
        }
    }

    .main-category > .block-img,
    .other-category > img {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        mask-image: linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5) 80%);
        object-fit: cover;
    }

    .main-category > div,
    .other-category > div {
        text-align: right;
        font-family: $serif;
    }

    .main-category > div {
        position: absolute;
        left: 48px;
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
        line-height: 36px;
        font-weight: 700;

        @media #{$tablet} {
            font-size: 28px;
        }

        @media #{$tablet-inv} {
            font-size: 36px;
        }
    }

    .other-category > div {
        @media #{$tablet} {
            font-size: 18px;
        }

        @media #{$tablet-inv} {
            font-size: 24px;
        }
    }

    .other-category {
        position: relative;
        flex: 1 0 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @extend .button;
    }

    .other-category:nth-last-child(n + 2) {
        margin-bottom: 16px;
    }

    #feed-container {
        display: flex;
        flex-flow: column nowrap;

        @media #{$tablet} {
            width: 100%;
            margin-top: 32px;
        }

        @media #{$tablet-inv} {
            width: 55%;
        }
    }

    #infoblocks-container {
        display: flex;
        flex-flow: column nowrap;
        top: 64px;
        align-self: flex-start;

        @media #{$tablet} {
            width: 100%;
        }

        @media #{$tablet-inv} {
            position: sticky;
            width: 40%;
            margin-right: 5%;
        }
    }

    .infoblock:nth-child(n + 2) {
        margin-top: 32px;
    }

    #feed-title {
        height: 48px;
        font-size: 36px;
        line-height: 48px;
        font-weight: 700;
        font-family: $serif;
        border-bottom: $dotted;
        border-top: none;
        padding: 0;
        text-align: left;
        top: 64px;

        @media #{$tablet-inv} {
            position: sticky;
            z-index: 2;
            background-color: $p-bg;
            box-shadow: $p-bg 0 0 32px 16px;
        }
    }

    #feed-title:active {
        background-color: $p-fg;
    }

    .post {
        margin-top: 32px;
    }
</style>